export enum EDashboardVisualization {
  TIMELINE_VALUE = 0,
  TIMELINE_LBL = 'タイムラインビュー',
  FOLDER_VALUE = 1,
  FOLDER_LBL = 'フォルダビュー',
  TIMELINE_DASHBOARD_TITLE = 'Search knowledge',
  FOLDER_DASHBOARD_TITLE = 'Search knowledge'
}
